/**
 * IDRA Living V3 PDP interactions — scoped to .custom-single-product
 * Theme-update safe: does not depend on theme.js internals except product-form submit.
 */
(function () {
  'use strict';

  function root() {
    return document.querySelector('.custom-single-product');
  }

  function qs(sel, el) {
    return (el || document).querySelector(sel);
  }

  function qsa(sel, el) {
    return Array.from((el || document).querySelectorAll(sel));
  }

  window.idraPdpShowMobileStep = function (index) {
    var track = qs('.tabs-cards-main');
    var cards = qsa('.tabs-cards-main .tab-card');
    var btns = qsa('.mobile-steps-nav .step-btn');
    var card;
    if (index < 0) index = 0;
    if (index >= cards.length) index = cards.length - 1;

    btns.forEach(function (btn, i) {
      btn.classList.toggle('active', i === index);
    });
    cards.forEach(function (item, i) {
      item.classList.toggle('active-card', i === index);
    });

    card = cards[index];
    if (
      track &&
      card &&
      window.matchMedia('(max-width: 767px)').matches
    ) {
      track.scrollTo({ left: card.offsetLeft, behavior: 'smooth' });
    }
  };

  function initMobileSteps() {
    var track = qs('.tabs-cards-main');
    var cards = qsa('.tabs-cards-main .tab-card');
    if (!track || cards.length < 2) return;
    if (track.dataset.idraStepsBound === '1') return;
    track.dataset.idraStepsBound = '1';
    track.setAttribute('tabindex', '0');

    track.addEventListener(
      'scroll',
      function () {
        if (!window.matchMedia('(max-width: 767px)').matches) return;
        var best = 0;
        var min = Infinity;
        cards.forEach(function (card, i) {
          var distance = Math.abs(card.offsetLeft - track.scrollLeft);
          if (distance < min) {
            min = distance;
            best = i;
          }
        });
        qsa('.mobile-steps-nav .step-btn').forEach(function (btn, i) {
          btn.classList.toggle('active', i === best);
        });
        cards.forEach(function (card, i) {
          card.classList.toggle('active-card', i === best);
        });
      },
      { passive: true }
    );
  }

  window.idraPdpScrollFeatures = function (direction) {
    var slider = qs('#features-slider');
    if (!slider) return;
    var maxScroll = Math.max(0, slider.scrollWidth - slider.clientWidth);
    var next = Math.max(0, Math.min(maxScroll, slider.scrollLeft + slider.offsetWidth * direction));
    slider.scrollTo({ left: next, behavior: 'smooth' });
  };

  function gallerySlides() {
    return qsa('.gallery-slide', qs('#gallery-track') || document);
  }

  function visibleGallerySlides() {
    return gallerySlides().filter(function (slide) {
      return !slide.classList.contains('is-pack-hidden');
    });
  }

  function packHints(pack) {
    var hints = {
      '13': ['kit_12', '12_filtr', '13_filtr', '13_filtri', '13 filtri'],
      '7': ['kit_all', '7_filtr', '7_filtri', '7 filtri'],
      '1': ['kit_1_filtro', '1_filtro', '1 filtro', 'kit_starter']
    };
    return hints[String(pack)] || [];
  }

  function slideHaystack(slide) {
    return (
      (slide.getAttribute('src') || '') +
      ' ' +
      (slide.getAttribute('href') || '') +
      ' ' +
      (slide.getAttribute('alt') || '')
    ).toLowerCase();
  }

  function pickCoverSlide(pack) {
    var visible = visibleGallerySlides();
    var hints = packHints(pack);
    var h;
    var i;
    for (h = 0; h < hints.length; h++) {
      var needle = hints[h].toLowerCase();
      for (i = 0; i < visible.length; i++) {
        if (slideHaystack(visible[i]).indexOf(needle) !== -1) return visible[i];
      }
    }
    if (pack) {
      for (i = 0; i < visible.length; i++) {
        if (visible[i].getAttribute('data-pack') === pack) return visible[i];
      }
    }
    return visible[0] || null;
  }

  function bindGalleryFancybox() {
    if (typeof Fancybox === 'undefined') return;
    try {
      Fancybox.unbind('[data-fancybox="idra-gallery"]');
    } catch (e) {
      /* first bind */
    }
    Fancybox.bind('[data-fancybox="idra-gallery"]', {});
  }

  function rebuildGalleryDots() {
    var dotsContainer = qs('#gallery-dots-container');
    if (!dotsContainer) return;
    var visible = visibleGallerySlides();
    dotsContainer.innerHTML = '';
    visible.forEach(function (slide) {
      var dot = document.createElement('span');
      dot.className = 'dot';
      dot.addEventListener('click', function () {
        activateGalleryMedia(slide.getAttribute('data-media-id'));
      });
      dotsContainer.appendChild(dot);
    });
  }

  function activateGalleryMedia(mediaId, options) {
    if (!mediaId) return;
    var id = String(mediaId);
    var visible = visibleGallerySlides();
    var activeVisibleIndex = 0;
    var activeSlide = null;
    var skipScroll = options && options.skipScroll;

    gallerySlides().forEach(function (slide) {
      var on = slide.getAttribute('data-media-id') === id;
      slide.classList.toggle('active-slide', on);
      if (on) activeSlide = slide;
    });
    qsa('.product-thumbnails img').forEach(function (thumb) {
      thumb.classList.toggle('active', thumb.getAttribute('data-media-id') === id);
    });
    visible.forEach(function (slide, index) {
      if (slide.getAttribute('data-media-id') === id) activeVisibleIndex = index;
    });
    qsa('#gallery-dots-container .dot').forEach(function (dot, index) {
      dot.classList.toggle('active', index === activeVisibleIndex);
    });

    if (!skipScroll && window.innerWidth <= 767) {
      var track = qs('#gallery-track');
      if (track && activeSlide && !activeSlide.classList.contains('is-pack-hidden')) {
        track.scrollTo({ left: activeSlide.offsetLeft, behavior: 'smooth' });
      }
    }
  }

  function filterGalleryForPack(pack) {
    var selectedPack = pack || '';
    gallerySlides().forEach(function (slide) {
      var slidePack = slide.getAttribute('data-pack') || '';
      var hide = selectedPack !== '' && slidePack !== '' && slidePack !== selectedPack;
      slide.classList.toggle('is-pack-hidden', hide);
      if (hide) {
        slide.setAttribute('hidden', '');
      } else {
        slide.removeAttribute('hidden');
      }
      slide.setAttribute('aria-hidden', hide ? 'true' : 'false');
      if (hide) {
        slide.removeAttribute('data-fancybox');
      } else {
        slide.setAttribute('data-fancybox', 'idra-gallery');
      }
    });
    qsa('.product-thumbnails img').forEach(function (thumb) {
      var thumbPack = thumb.getAttribute('data-pack') || '';
      var hide = selectedPack !== '' && thumbPack !== '' && thumbPack !== selectedPack;
      thumb.classList.toggle('is-pack-hidden', hide);
      if (hide) {
        thumb.setAttribute('hidden', '');
      } else {
        thumb.removeAttribute('hidden');
      }
    });

    var thumbs = qs('.product-thumbnails');
    if (thumbs) {
      thumbs.classList.toggle('is-single-pack', visibleGallerySlides().length <= 1);
    }

    rebuildGalleryDots();
    bindGalleryFancybox();

    var cover = pickCoverSlide(selectedPack);
    if (cover) activateGalleryMedia(cover.getAttribute('data-media-id'));
  }

  window.idraPdpUpdateGalleryDots = function () {
    var track = qs('#gallery-track');
    if (!track) return;
    var slides = visibleGallerySlides();
    var dots = qsa('#gallery-dots-container .dot');
    var activeIndex = 0;
    var minDistance = Infinity;

    slides.forEach(function (slide, index) {
      var distance = Math.abs(slide.offsetLeft - track.scrollLeft);
      if (distance < minDistance) {
        minDistance = distance;
        activeIndex = index;
      }
    });

    dots.forEach(function (dot, index) {
      dot.classList.toggle('active', index === activeIndex);
    });

    if (window.innerWidth <= 767 && slides[activeIndex]) {
      activateGalleryMedia(slides[activeIndex].getAttribute('data-media-id'), {
        skipScroll: true
      });
    }
  };

  window.idraPdpOpenFancybox = function () {
    var activeSlide =
      qs('.gallery-slide.active-slide:not(.is-pack-hidden)') ||
      visibleGallerySlides()[0];
    if (activeSlide) activeSlide.click();
  };

  function initGallery() {
    var thumbsRoot = qs('.product-thumbnails');
    if (thumbsRoot && thumbsRoot.dataset.idraGalleryBound !== '1') {
      thumbsRoot.dataset.idraGalleryBound = '1';
      thumbsRoot.addEventListener('click', function (event) {
        var thumb = event.target.closest('img[data-media-id]');
        if (!thumb || thumb.classList.contains('is-pack-hidden')) return;
        activateGalleryMedia(thumb.getAttribute('data-media-id'));
      });
    }
    bindGalleryFancybox();
  }

  function initFaq() {
    qsa('.sngl-faqs').forEach(function (faqRoot) {
      var faqTabs = Array.from(faqRoot.querySelectorAll('.faq-tabs-inner a'));
      var faqWrappers = Array.from(faqRoot.querySelectorAll('.faqs-main-wrapper'));

      faqTabs.forEach(function (tab, index) {
        if (tab.dataset.idraFaqBound === '1') return;
        tab.dataset.idraFaqBound = '1';
        tab.addEventListener('click', function (e) {
          e.preventDefault();
          faqTabs.forEach(function (t) {
            t.classList.remove('active');
          });
          tab.classList.add('active');
          faqWrappers.forEach(function (w) {
            w.style.display = 'none';
          });
          if (faqWrappers[index]) faqWrappers[index].style.display = 'block';
        });
      });

      Array.from(faqRoot.querySelectorAll('.faq-ques')).forEach(function (ques) {
        if (ques.dataset.idraFaqBound === '1') return;
        ques.dataset.idraFaqBound = '1';
        ques.addEventListener('click', function () {
          ques.parentElement.classList.toggle('active');
        });
      });
    });
  }

  function initHotspots() {
    ensureBottomSheet();

    qsa('.sngl-prdct-img-hover-sec .idra-hotspot').forEach(function (hotspot) {
      if (hotspot.dataset.idraHotspotBound === '1') return;
      hotspot.dataset.idraHotspotBound = '1';
      hotspot.setAttribute('role', 'button');
      hotspot.setAttribute('tabindex', '0');

      function activate(e) {
        if (e) {
          e.preventDefault();
          e.stopPropagation();
        }

        if (window.innerWidth <= 767) {
          openBottomSheet(hotspot);
          return;
        }

        var wasOpen = hotspot.classList.contains('is-open');
        qsa('.sngl-prdct-img-hover-sec .idra-hotspot.is-open').forEach(function (el) {
          el.classList.remove('is-open');
        });
        if (!wasOpen) hotspot.classList.add('is-open');
      }

      hotspot.addEventListener('click', activate);
      hotspot.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') activate(e);
      });
    });

    if (document.documentElement.dataset.idraHotspotDocBound === '1') return;
    document.documentElement.dataset.idraHotspotDocBound = '1';
    document.addEventListener('click', function () {
      qsa('.sngl-prdct-img-hover-sec .idra-hotspot.is-open').forEach(function (el) {
        el.classList.remove('is-open');
      });
    });
  }

  function ensureBottomSheet() {
    if (qs('.idra-mobile-bottom-sheet')) return;

    var overlay = document.createElement('div');
    overlay.className = 'idra-bottom-sheet-overlay';

    var sheet = document.createElement('div');
    sheet.className = 'idra-mobile-bottom-sheet';
    sheet.innerHTML =
      '<div class="idra-mobile-bottom-sheet-handle"></div>' +
      '<div class="idra-mobile-bottom-sheet-content"></div>';

    document.body.appendChild(overlay);
    document.body.appendChild(sheet);

    overlay.addEventListener('click', closeBottomSheet);
    sheet.addEventListener('click', function (e) {
      if (
        e.target.classList.contains('idra-mobile-bottom-sheet-handle') ||
        e.target.tagName === 'H4' ||
        e.offsetY < 40
      ) {
        closeBottomSheet();
      }
    });

    var startY = null;
    sheet.addEventListener(
      'touchstart',
      function (e) {
        startY = e.touches[0].clientY;
      },
      { passive: true }
    );
    sheet.addEventListener(
      'touchmove',
      function (e) {
        if (startY == null) return;
        if (e.touches[0].clientY > startY + 50) {
          closeBottomSheet();
          startY = null;
        }
      },
      { passive: true }
    );
  }

  function openBottomSheet(hotspot) {
    var overlay = qs('.idra-bottom-sheet-overlay');
    var sheet = qs('.idra-mobile-bottom-sheet');
    var content = qs('.idra-mobile-bottom-sheet-content');
    var tooltip = hotspot.querySelector('.idra-hotspot-tooltip');
    if (!overlay || !sheet || !content || !tooltip) return;

    content.innerHTML = tooltip.innerHTML;
    overlay.classList.add('active');
    sheet.classList.add('active');
    document.body.classList.add('idra-no-scroll');
  }

  function closeBottomSheet() {
    var overlay = qs('.idra-bottom-sheet-overlay');
    var sheet = qs('.idra-mobile-bottom-sheet');
    if (overlay) overlay.classList.remove('active');
    if (sheet) sheet.classList.remove('active');
    document.body.classList.remove('idra-no-scroll');
  }

  function initProductDetailsToggle() {
    var details = qs('#productDetailsContent');
    var btn = qs('#productReadMore');
    if (!details || !btn || btn.dataset.idraReadMoreBound === '1') return;
    btn.dataset.idraReadMoreBound = '1';

    btn.addEventListener('click', function () {
      var expanded = details.classList.toggle('is-expanded');
      var moreLabel = btn.getAttribute('data-more-label') || 'Leggi di più';
      var lessLabel = btn.getAttribute('data-less-label') || 'Leggi di meno';
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      btn.textContent = expanded ? lessLabel : moreLabel;
    });
  }

  function featureSliderMetrics(slider, slides) {
    var first = slides[0];
    var gap = 0;
    var stride = 0;
    var maxScroll = Math.max(0, slider.scrollWidth - slider.clientWidth);
    var pageCount = 1;
    var styles;

    if (!first) {
      return { stride: 0, maxScroll: 0, pageCount: 1 };
    }

    styles = window.getComputedStyle(slider);
    gap = parseFloat(styles.columnGap || styles.gap) || 0;
    stride = first.getBoundingClientRect().width + gap;

    if (stride > 1 && maxScroll > 1) {
      pageCount = Math.round(maxScroll / stride) + 1;
    }

    return {
      stride: stride,
      maxScroll: maxScroll,
      pageCount: Math.max(1, pageCount)
    };
  }

  function featureSliderPage(slider, metrics) {
    if (metrics.pageCount <= 1 || metrics.stride <= 0) return 0;
    if (slider.scrollLeft >= metrics.maxScroll - 2) return metrics.pageCount - 1;
    return Math.max(
      0,
      Math.min(metrics.pageCount - 1, Math.round(slider.scrollLeft / metrics.stride))
    );
  }

  function initFeaturesPagination() {
    var slider = qs('#features-slider');
    var pagination = qs('#features-pagination');
    if (!slider || !pagination) return;

    var slides = Array.from(slider.querySelectorAll('.sngl-prdct-ftr-slide'));
    if (slides.length === 0) return;

    function renderDots() {
      var metrics = featureSliderMetrics(slider, slides);
      var current = featureSliderPage(slider, metrics);
      var i;
      var dot;

      pagination.innerHTML = '';
      pagination.classList.toggle('is-single-page', metrics.pageCount <= 1);
      if (metrics.pageCount <= 1) return;

      for (i = 0; i < metrics.pageCount; i++) {
        dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'dot' + (i === current ? ' active' : '');
        dot.setAttribute('aria-label', 'Pagina ' + (i + 1) + ' di ' + metrics.pageCount);
        if (i === current) dot.setAttribute('aria-current', 'true');
        dot.addEventListener(
          'click',
          (function (index) {
            return function () {
              var latest = featureSliderMetrics(slider, slides);
              slider.scrollTo({
                left: Math.min(index * latest.stride, latest.maxScroll),
                behavior: 'smooth'
              });
            };
          })(i)
        );
        pagination.appendChild(dot);
      }
    }

    function syncActive() {
      var metrics = featureSliderMetrics(slider, slides);
      var dots = Array.from(pagination.querySelectorAll('.dot'));
      var current;
      if (dots.length !== metrics.pageCount) {
        renderDots();
        return;
      }
      current = featureSliderPage(slider, metrics);
      dots.forEach(function (dot, index) {
        var isActive = index === current;
        dot.classList.toggle('active', isActive);
        if (isActive) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    if (pagination.dataset.idraFeaturesBound !== '1') {
      pagination.dataset.idraFeaturesBound = '1';
      slider.addEventListener('scroll', syncActive, { passive: true });
      if (typeof ResizeObserver !== 'undefined') {
        new ResizeObserver(renderDots).observe(slider);
      } else {
        window.addEventListener('resize', renderDots);
      }
    }

    renderDots();
  }

  function initSectionTabs() {
    var links = qsa('.sngl-tabs-list a[href^="#"]');
    var tabsSection = qs('.sngl-prdct-tabs-section');
    var sentinel = qs('.sngl-prdct-tabs-sentinel');
    var backBtn = qs('.sngl-tabs-back-top');
    var toBarBtn = qs('.idra-tabs-to-bar');
    if (!links.length) return;

    function isMobileTabs() {
      return window.matchMedia('(max-width: 767px)').matches;
    }

    function headerHeight() {
      var raw = getComputedStyle(document.documentElement).getPropertyValue(
        '--sticky-header-height'
      );
      var header = parseFloat(raw) || 0;
      if (!header) {
        var el =
          document.querySelector('sticky-header') ||
          document.querySelector('#shopify-section-header');
        if (el) header = el.getBoundingClientRect().height;
      }
      return header;
    }

    function headerOffset() {
      var header = headerHeight();
      var tabH = 0;
      if (tabsSection && !isMobileTabs()) {
        tabH = tabsSection.getBoundingClientRect().height;
        document.documentElement.style.setProperty(
          '--idra-sticky-tabs-height',
          tabH.toFixed(1) + 'px'
        );
      } else {
        document.documentElement.style.setProperty('--idra-sticky-tabs-height', '0px');
      }
      return header + tabH + 8;
    }

    function activate(link) {
      links.forEach(function (a) {
        a.classList.toggle('current', a === link);
      });
    }

    function scrollToId(id) {
      var target = document.getElementById(id);
      if (!target) return false;
      var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset();
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      return true;
    }

    links.forEach(function (link) {
      if (link.dataset.idraTabBound === '1') return;
      link.dataset.idraTabBound = '1';
      link.addEventListener('click', function (e) {
        var href = link.getAttribute('href') || '';
        var id = href.charAt(0) === '#' ? href.slice(1) : '';
        if (!id) return;
        if (!scrollToId(id)) return;
        e.preventDefault();
        activate(link);
        if (history.replaceState) history.replaceState(null, '', href);
      });
    });

    if (backBtn && backBtn.dataset.idraBackBound !== '1') {
      backBtn.dataset.idraBackBound = '1';
      backBtn.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }

    if (!toBarBtn) {
      toBarBtn = document.createElement('button');
      toBarBtn.type = 'button';
      toBarBtn.className = 'idra-tabs-to-bar';
      toBarBtn.setAttribute('aria-label', 'Torna su');
      toBarBtn.innerHTML =
        '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 19V5"></path><path d="M5 12l7-7 7 7"></path></svg>';
    }
    if (toBarBtn.parentNode !== document.body) {
      document.body.appendChild(toBarBtn);
    }

    function tabsBarScrolledAway() {
      if (!tabsSection) return false;
      return tabsSection.getBoundingClientRect().bottom < headerHeight() + 4;
    }

    function updateToBarVisibility() {
      var show = tabsBarScrolledAway();
      toBarBtn.classList.toggle('is-visible', show);
      toBarBtn.setAttribute('aria-hidden', show ? 'false' : 'true');
      toBarBtn.tabIndex = show ? 0 : -1;
    }

    if (toBarBtn.dataset.idraToBarBound !== '1') {
      toBarBtn.dataset.idraToBarBound = '1';
      toBarBtn.addEventListener('click', function () {
        if (!tabsSection) return;
        var top =
          tabsSection.getBoundingClientRect().top + window.pageYOffset - headerHeight() - 8;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      });
      window.addEventListener('scroll', updateToBarVisibility, { passive: true });
      window.addEventListener('resize', updateToBarVisibility);
    }
    updateToBarVisibility();

    if (sentinel && tabsSection && tabsSection.dataset.idraStickyBound !== '1') {
      tabsSection.dataset.idraStickyBound = '1';
      new IntersectionObserver(
        function (entries) {
          var entry = entries[0];
          var stuck = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          var showBack = stuck && !isMobileTabs();
          tabsSection.classList.toggle('is-stuck', stuck);
          if (backBtn) {
            backBtn.setAttribute('aria-hidden', showBack ? 'false' : 'true');
            backBtn.tabIndex = showBack ? 0 : -1;
          }
          updateToBarVisibility();
        },
        { threshold: 0 }
      ).observe(sentinel);
    }

    if (tabsSection && tabsSection.dataset.idraSpyBound !== '1') {
      tabsSection.dataset.idraSpyBound = '1';
      var targets = links
        .map(function (link) {
          var href = link.getAttribute('href') || '';
          var id = href.charAt(0) === '#' ? href.slice(1) : '';
          return { link: link, el: id ? document.getElementById(id) : null };
        })
        .filter(function (item) {
          return item.el;
        });

      window.addEventListener(
        'scroll',
        function () {
          var offset = headerOffset();
          var current = targets[0];
          var i;
          for (i = 0; i < targets.length; i++) {
            if (targets[i].el.getBoundingClientRect().top - offset <= 12) {
              current = targets[i];
            }
          }
          if (current) activate(current.link);
        },
        { passive: true }
      );
      headerOffset();
    }
  }

  function syncStickyAtc() {
    var form = qs('#IdraProductForm');
    var stickyBtn = qs('.idra-sticky-atc__btn');
    var source;
    if (!form || !stickyBtn) return;
    source = form.querySelector('[type="submit"]');
    if (!source) return;
    stickyBtn.disabled = source.disabled;
    stickyBtn.textContent = (source.textContent || '').trim();
  }

  function initStickyAtc() {
    var bar = qs('#idra-sticky-atc');
    var form = qs('#IdraProductForm');
    var footer;
    var hidePadTimer = 0;
    var ticking = false;

    function sourceBtn() {
      return form ? form.querySelector('[type="submit"]') : null;
    }

    function shouldShow() {
      var btn = sourceBtn();
      var vh;
      var footerTop;
      if (!btn) return false;
      vh = window.innerHeight;
      if (btn.getBoundingClientRect().bottom > 0) return false;
      if (!footer) return true;
      footerTop = footer.getBoundingClientRect().top;
      return footerTop >= vh - 16;
    }

    function update() {
      var show;
      if (!bar) return;
      show = shouldShow();
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (show) {
        if (hidePadTimer) {
          window.clearTimeout(hidePadTimer);
          hidePadTimer = 0;
        }
        document.body.classList.add('idra-sticky-atc-open');
        return;
      }
      if (hidePadTimer) window.clearTimeout(hidePadTimer);
      hidePadTimer = window.setTimeout(function () {
        hidePadTimer = 0;
        if (!bar.classList.contains('is-visible')) {
          document.body.classList.remove('idra-sticky-atc-open');
        }
      }, 380);
    }

    function onScrollTick() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        update();
      });
    }

    syncStickyAtc();
    if (!bar || !form || bar.dataset.idraStickyAtcBound === '1') return;
    bar.dataset.idraStickyAtcBound = '1';

    footer = document.querySelector('.footer-group') || document.querySelector('footer');

    window.addEventListener('scroll', onScrollTick, { passive: true });
    window.addEventListener('resize', onScrollTick);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', onScrollTick);
      window.visualViewport.addEventListener('scroll', onScrollTick, { passive: true });
    }
    update();
  }

  function initHoverButtons() {
    var selector =
      '.btn-cta-primary, .btn-cta-secondary, .add-to-cart-btn, .sngl-tabs-list a, .btn-view-reviews, .btn-follow, .faq-tabs-inner a, .btn-buy-ritual, .btn-view-video';
    qsa(selector).forEach(function (btn) {
      if (btn.dataset.idraHoverBound === '1') return;
      btn.dataset.idraHoverBound = '1';
      btn.addEventListener('mouseenter', function () {
        if (window.matchMedia('(max-width: 767px), (hover: none)').matches) return;
        this.classList.remove('leave');
        this.classList.add('enter');
      });
      btn.addEventListener('mouseleave', function () {
        this.classList.remove('enter');
        this.classList.add('leave');
      });
    });
  }

  function selectVariantCard(form, card, radio) {
    var idInput = form.querySelector('[name="id"]');
    var submitBtn = form.querySelector('[type="submit"]');
    var cards = qsa('.option-card', form);

    cards.forEach(function (c) {
      c.classList.toggle('selected', c === card);
      c.classList.toggle('active', c === card);
    });
    if (idInput) {
      idInput.disabled = false;
      idInput.value = radio.value;
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (submitBtn) {
      submitBtn.disabled = radio.disabled;
    }
    syncStickyAtc();
    filterGalleryForPack(radio.getAttribute('data-pack'));
  }

  function initVariantCards(form) {
    if (!form) return;
    var cards = qsa('.option-card', form);

    cards.forEach(function (card) {
      var radio = card.querySelector('input[type="radio"]');
      if (!radio || radio.dataset.idraVariantBound === '1') return;
      radio.dataset.idraVariantBound = '1';

      radio.addEventListener('change', function () {
        selectVariantCard(form, card, radio);
      });
    });

    var selected = form.querySelector('input[name="idra_variant"]:checked');
    filterGalleryForPack(selected ? selected.getAttribute('data-pack') : '');
  }

  function init() {
    if (!root()) return;
    initGallery();
    initFaq();
    initHotspots();
    initProductDetailsToggle();
    initFeaturesPagination();
    initSectionTabs();
    initMobileSteps();
    initStickyAtc();
    initHoverButtons();
    initVariantCards(qs('#IdraProductForm'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector('.custom-single-product')) {
      init();
    }
  });
})();
